// Produktbild beim Scrollen vertikal zentrieren (Desktop)
(function(){
function init(){
 var pp=document.getElementById('pp');
 if(!pp)return;
 var col=pp.querySelector(':scope > div:first-child');
 if(!col)return;
 function upd(){
  if(window.innerWidth<901){col.style.top='';return}
  var h=col.offsetHeight, vh=window.innerHeight;
  var top=(vh-h)/2;
  if(top<80)top=80; // nicht unter den Sticky-Header rutschen
  col.style.top=top+'px';
 }
 upd();
 window.addEventListener('resize',upd);
 // Bildwechsel (Galerie) kann Höhe ändern
 new MutationObserver(upd).observe(col,{subtree:true,attributes:true,attributeFilter:['src']});
 setTimeout(upd,600);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
